class OffersPortalStateSelect {
  constructor() {
    this.offersStateSelector = document.querySelector(
      '[data-offers-state-selector]'
    );
    this.offersStateDropdown = document.querySelector(
      '.offers-portal__state-dropdown'
    );
    this.selectedFilterText = document.querySelector('.selected-filter-text');
    this.offersUrls = document.querySelectorAll('[data-offers-url]');
    this.init();
  }

  init() {
    if (this.offersStateSelector) {
      // Handle click of state selector
      this.offersStateSelector.addEventListener('click', () => {
        // show/hide dropdown
        if (this.offersStateDropdown.style.display !== 'block') {
          this.offersStateDropdown.style.display = 'block';
        } else {
          this.offersStateDropdown.style.display = 'none';
        }
      });
    }

    this.offersUrls.forEach((filterLink) => {
      filterLink.addEventListener('click', (e) => {
        const offerUrl = e.currentTarget.dataset.offersUrl;
        const offerState = e.currentTarget.textContent;

        this.offersStateDropdown.style.display = 'none';

        document
          .querySelector('[data-visit-offers-button]')
          .setAttribute('href', offerUrl);
        this.selectedFilterText.textContent = offerState;
      });
    });
  }
}

export default 'OffersPortalStateSelect';

document.addEventListener(
  'DOMContentLoaded',
  () => new OffersPortalStateSelect()
);
